import { Menu, MenuItem } from "@mui/material";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";

/**
 * Menu to select languages
 * @param {object} props - Component properties
 * @param {HTMLElement} props.anchor - Anchor element for the menu
 * @param {Function} props.onClose - Function to call when closing the menu
 * @param {Array} props.languages - List of available languages
 * @param {Function} props.onClick - Function to call when a language is selected
 * @returns {JSX.Element} Rendered MenuLanguages component
 */
const MenuLanguages = ({ anchor, onClose, languages = [], onClick = () => {} }) => {
	return (
		<Menu anchorEl={anchor} open={Boolean(anchor)} onClose={onClose}>
			<MenuItem disabled style={{ opacity: 1 }}>
				<MDTypography variant="caption">{t("LANGUAGE.sourceLanguage")}</MDTypography>
			</MenuItem>
			{languages.map(lang => (
				<MenuItem
					key={lang.code}
					onClick={e => {
						onClick(lang.code);
					}}
				>
					{lang.logoURL && (
						<img
							src={lang.logoURL}
							alt={lang.code}
							style={{
								width: "20px",
								height: "20px",
								borderRadius: "50%",
								marginRight: "10px"
							}}
						/>
					)}
					<MDTypography variant="body2" fontWeight="bold" fontSize="small">
						{lang?.name}
					</MDTypography>
				</MenuItem>
			))}
		</Menu>
	);
};

export default MenuLanguages;
